// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__1jMTp","tabsList":"tabs_tabsList__2glxc","tabContent":"tabs_tabContent__2nW9z"};